module.exports = __webpack_public_path__ + "media/svg-new/boss5-cc7ddc8d.svg";